import { Users } from 'lucide-react';
import { useSupport } from '../../../../../../context/support/SupportContext';
import { supportData } from '../../../../utils/supportHelpers';
import ChatListHeader from './sections/ChatListHeader';
import ChatListItem from './sections/ChatListItem';

const ChatList = ({ isChatUnlocked }) => {
  const {
    loadingChats,
    travellerChats,
    getFilteredTravellerChats,
    selectedChatBookingId,
    selectedChatGuestName,
    handleSelectChat
  } = useSupport();

  const filteredChats = getFilteredTravellerChats(isChatUnlocked);

  return (
    <div
      className={`w-full md:w-80 lg:w-96 flex-shrink-0 flex flex-col border-r border-gray-200 bg-gray-50/40 ${
        selectedChatBookingId ? 'hidden md:flex' : 'flex'
      }`}
    >
      <ChatListHeader chatCount={travellerChats.length} />

      <div className="flex-1 overflow-y-auto custom-scrollbar bg-white divide-y divide-gray-100">
        {loadingChats ? (
          <div className="flex justify-center p-12">
            <div className="animate-spin h-6 w-6 border-2 border-[#067978] border-t-transparent rounded-full" />
          </div>
        ) : filteredChats.length === 0 ? (
          <div className="p-12 text-center text-gray-400 space-y-2">
            <Users className="mx-auto text-gray-300" size={32} />
            <p className="text-xs font-medium">{supportData.emptyStates.noTravellerChats.title}</p>
            <p className="text-[10px] text-gray-400">
              {supportData.emptyStates.noTravellerChats.description}
            </p>
          </div>
        ) : (
          filteredChats.map((chat) => {
            const isSelected =
              selectedChatBookingId &&
              selectedChatBookingId.toLowerCase() === chat.booking_id?.toLowerCase() &&
              selectedChatGuestName &&
              selectedChatGuestName.toLowerCase() === (chat.guest_name || '').toLowerCase();

            return (
              <ChatListItem
                key={chat._id}
                chat={chat}
                isSelected={isSelected}
                onSelect={handleSelectChat}
              />
            );
          })
        )}
      </div>
    </div>
  );
};

export default ChatList;
